module.exports = __webpack_public_path__ + "1b6a69763801a6a63409f7ed63532bc0.svg";